import api from '../../../utils/api'

/* Hooks */
import useFlashMessage from '../../../hooks/useFlashMessage'

import AuthBackgroundImage from '../../../shared/components/AuthImage/AuthBackgroundImage'
//functions
import NumberToMoney from '../../../shared/functions/NumberToMoney'

import Input from '../../../shared/components/form/input'
import FormLayout from "../../../shared/components/FormLayout/FormLayout"
import FormSection from "../../../shared/components/FormLayout/FormSection"
import Button from "../../../shared/components/Button/Button"
import { useState } from "react"
import { Link } from "react-router-dom"

function FormAccessory({ handleSubmit, accessoryData, btnText, btCancelLink, btCancelAction, title }) {
    const isEdit = !!accessoryData
    const [preview, setPreview] = useState()
    const [accessory, setAccessory] = useState(accessoryData || {})
    const { setFlashMessage } = useFlashMessage()


    function onFileChange(e) {
        if(e.target.files[0]){
            if(e.target.files[0].size > 1 * 1000 * 1024){
                setFlashMessage("A imagem é maior que 1MB e não sera carregada", 'error')
                return
            }
        }
        setPreview(e.target.files[0])
        setAccessory({ ...accessory, [e.target.name]: e.target.files[0] })
    }
    function handleChange(e) {
        setAccessory({ ...accessory, [e.target.name]: e.target.value })
    }
    function handleChangeMoney(e) {

        let value = NumberToMoney(e.target.value)

        setAccessory({ ...accessory, [e.target.name]: value })


    }

    async function submit(e) {
        e.preventDefault()
        //validations
        if (!accessory.name) {
            setFlashMessage("O nome é obrigatório", 'error')
            return
        }
        if (!accessory.description) {
            setFlashMessage("A descrição é obrigatória", 'error')
            return
        }
        if (!accessory.price) {
            setFlashMessage("O preço de venda é obrigatório", 'error')
            return
        }
        // Custo só é obrigatório no cadastro novo — acessórios já existentes podem ser editados
        // (nome, preço, imagem) sem forçar o preenchimento retroativo do custo agora.
        if (!isEdit && !accessory.cost) {
            setFlashMessage("O custo é obrigatório", 'error')
            return
        }


        handleSubmit(accessory)

    }
    return (
        <FormLayout
            title={title}
            onSubmit={submit}
            actions={
                <>
                    <Button variant="save" type="submit">{btnText || 'Salvar'}</Button>
                    {btCancelLink
                        ? <Link className="link-default" to={btCancelLink}><Button variant="cancel">Cancelar</Button></Link>
                        : btCancelAction && <Button variant="cancel" onClick={btCancelAction}>Cancelar</Button>
                    }
                </>
            }
        >
            <FormSection label="Imagem">
                <div className="fl-row">
                    <div className="form-group">
                        {preview ? (
                            <div className='shd-box-img-300x300 shd-bgimg-cover' style={{ backgroundImage: `url(${URL.createObjectURL(preview)})` }} > </div>
                        ) : accessory.image ? (
                            <AuthBackgroundImage className='shd-box-img-300x300 shd-bgimg-cover' src={`/images/accessory/${accessory.image}`} />
                        ) : <div className='shd-box-img-300x300' ></div>}

                        <div>Atenção: Não serão carregadas imagens maiores que 1MB</div>
                        <Input
                            text="imagem"
                            type="file"
                            name="image"
                            handleOnChange={onFileChange}
                        />
                    </div>
                </div>
            </FormSection>

            <FormSection label="Identificação">
                <div className="fl-row">
                    <div className="fl-col-wide form-group">
                        <Input
                            text="Nome"
                            type="text"
                            name="name"
                            value={accessory.name || ""}
                            handleOnChange={handleChange}
                        />
                    </div>
                    <div className="fl-col-narrow form-group">
                        <Input
                            text="Preço de Venda"
                            type="number"
                            name="price"
                            handleOnChange={handleChange}
                            handleOnBlur={handleChangeMoney}
                            value={accessory.price}
                        />
                    </div>
                    <div className="fl-col-narrow form-group">
                        <Input
                            text={`Custo${isEdit ? ' (opcional)' : ''}`}
                            type="number"
                            name="cost"
                            handleOnChange={handleChange}
                            handleOnBlur={handleChangeMoney}
                            value={accessory.cost}
                        />
                    </div>
                </div>
                <div className="fl-row">
                    <div className="fl-col-wide form-group">
                        <Input
                            text="Descrição"
                            type="textarea"
                            name="description"
                            value={accessory.description || ""}
                            handleOnChange={handleChange}
                            maxlength={"200"}
                        />
                    </div>
                </div>
            </FormSection>
        </FormLayout>
    )
}

export default FormAccessory
